<template>
  <b-navbar toggleable="md">
    <b-navbar-brand to="site/dashboard">
      <b-img src="/logo.png"></b-img>
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse" class="margin-bottom:10px;">
      <!-- <font-awesome-icon icon="hamburger"></font-awesome-icon> -->
    </b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item-dropdown left>
          <template slot="button-content">
            <span>Szablony</span>
          </template>
          <b-dropdown-item to="/site/vocabulary">Słownictwo</b-dropdown-item>
          <b-dropdown-item to="/site/subjects">Tematy</b-dropdown-item>
          <b-dropdown-item to="/site/courses">Kursy</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown left>
          <template slot="button-content">
            <span>Użytkownicy</span>
          </template>
          <b-dropdown-item to="/site/students">Kursanci</b-dropdown-item>
          <b-dropdown-item to="/site/lectors">Lektorzy</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item to="/site/reports" title="Raporty">
          <span>Raporty</span>
        </b-nav-item>

        <b-nav-item-dropdown left>
          <template slot="button-content">
            <span>Ustawienia</span>
          </template>
          <b-dropdown-item to="/site/emailSettings">Poczta</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item to="/site/calendar" title="Kalendarz">
          <span>Kalendarz</span>
        </b-nav-item>

        <b-nav-item to="/site/messaging" title="Wiadomości">
          <span>Wiadomości</span>
        </b-nav-item>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <!-- <b-nav-item to="/site/profile" title="Mój profil">
          <span>
            <font-awesome-icon icon="user" class="fa-fw"></font-awesome-icon>&nbsp;Mój profil
          </span>
        </b-nav-item>-->
        <b-nav-item @click="onLogout" title="Wyloguj się">Wyloguj się</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { tokenStore } from "@/_infrastructure";

export default {
  methods: {
    onLogout() {
      tokenStore.clearToken();
      this.$router.push("/public/login");
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar-brand img {
  max-height: 70px;
  margin: 0px;
}
div#nav-collapse {
  margin-left: 10px;
}
</style>